<template>
  <div class="page-container">
    <!-- 头部 -->
    <van-nav-bar
      fixed
      title="我的积分"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      id="vnb"
    >
      <span slot="right">积分说明</span>
    </van-nav-bar>

    <!-- 可用积分 -->
    <div class="lave">
      <div class="lave-box">
        <div class="lave-points">
          <div class="top">
            <span>{{ userInfo.custAccount.score }}</span>
          </div>
          <div class="down fy">
            <span @click="mingxiClick">可用积分</span>
            <van-icon name="arrow" class="icon" color="#FFFFFF" />
          </div>
        </div>
        <div class="line"></div>
        <div class="lave-earn fy">
          <van-button @click="laveClick">赚取积分</van-button>
        </div>
      </div>
    </div>

    <!-- 实物兑换 -->
    <div class="convert fy">
      <span>实物兑换</span>
    </div>

    <!-- 实物兑换列表 -->
    <div class="goods">
      <div class="goods-list">
        <router-link
          :to="{ name: 'shop-product', params: { id: item.id } }"
          class="goods-list-item"
          v-for="(item, index) in goods"
          :key="index"
        >
          <!-- <img :src="item.coverImg" alt /> -->
          <!-- 懒加载图片 -->
          <img :src="item.coverImg" alt />
          <div class="text fy">{{ item.title }}</div>
          <div class="price fy">市场价：{{ item.oldPriceStr }}元</div>
          <van-button
            block
            square
            type="warning"
            class="bg-color-orange-shop fy"
          >{{ item.scoreStr }}积分</van-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

import * as GoodsApi from '@/api/goods';
import { Image as VanImage } from 'vant';
import { mapGetters } from 'vuex';
import { Toast, Icon } from 'vant';

export default {
  data () {
    return {
      goods: []
    };
  },
  beforeMount () {
    // 实物兑换
    GoodsApi.list({ pageNo: 1, pageSize: 10 })
      .then(data => {
        this.goods = data.list;
      })
      .catch(e => {
        Toast(e.msg || e.message);
      });
  },
  methods: {
    // 回退
    onClickLeft () {
      // Toast('返回');
      // console.log('点击了返回');
      // this.$router.push('/user');
      this.goableBack()
    },
    // 积分说明
    onClickRight () {
      // Toast('按钮');
      this.$router.push('/description');
    },
    // 赚取积分
    laveClick () {
      // console.log(123)
      this.$router.push('/rebatepoints');
    },
    // 可用积分
    mingxiClick () {
      this.$router.push('/pointsmingxi')
    }
  },
  computed: {
    ...mapGetters(['channel', 'os', 'token', 'userInfo'])
  },
  components: {
    [VanImage.name]: VanImage,
    [Icon.name]: Icon
  }
  // data () {
  //   return {
  //     goods: []
  //   };
  // },
  // beforeMount () {
  //   // 实物兑换
  //   GoodsApi.list({ pageNo: 1, pageSize: 10 })
  //     .then(data => {
  //       this.goods = data.list;
  //     })
  //     .catch(e => {
  //       Toast(e.msg || e.message);
  //     });
  // },
  // methods: {
  //   // 回退
  //   onClickLeft () {
  //     // Toast('返回');
  //     // console.log('点击了返回');
  //     // this.$router.push('/user');
  //     this.goableBack()
  //   },
  //   // 积分说明
  //   onClickRight () {
  //     // Toast('按钮');
  //     this.$router.push('/description');
  //   },
  //   // 赚取积分
  //   laveClick () {
  //     // console.log(123)
  //     this.$router.push('/rebatepoints');
  //   },
  //   // 可用积分
  //   mingxiClick () {

  //   }
  // },
  // computed: {
  //   ...mapGetters(['channel', 'os', 'token', 'userInfo'])
  // },
  // components: {
  //   [VanImage.name]: VanImage
  // }
};
</script>

<style lang="less" scoped>
.container {
  background-color: #f3f4f6;
}

// navBar
/deep/ .van-nav-bar {
  background-color: #ffffff !important;
  background-image: none;
}

#vnb /deep/ .van-nav-bar__title {
  color: #000000 !important;
  font-size: 16px;
  font-family: 'PingFangSC Medium';
}
#vnb /deep/ .van-nav-bar__left .van-icon {
  color: #000000 !important;
  font-size: 16px;
}

#vnb /deep/ .van-nav-bar__right span {
  color: #777777 !important;
  font-size: 14px;
}

// 可用积分
.lave {
  margin: 20px 15px 0 15px;
  position: relative;

  .lave-box {
    height: 112px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px;
    background-image: url('../../assets/img/pointsmall/bjt.png');
    background-size: 375px;
    // 可用积分
    .lave-points {
      flex: 1;
      // border: 1px solid greenyellow;
      text-align: center;

      .top {
        span {
          color: #ffffff;
          font-size: 22px;
        }
      }
      .down {
        display: flex;
        justify-content: center;

        span {
          color: #ffffff;
          font-size: 14px;
          text-align: center;
        }

        .icon {
          margin-top: 4px;
        }
      }
    }
    // 赚取积分
    .lave-earn {
      flex: 1;
      text-align: center;
      // border: 1px solid greenyellow;
      button {
        padding: 3px 15px;
        color: #7c5740;
        background-color: #fee0b4;
        border-radius: 50px;
        border: none;
        background-image: url('../../assets/img/pointsmall/anniu.png');
        // background-size: 375px;
      }
    }
    // line
    .line {
      height: 30px;
      width: 1px;
      background-repeat: repeat;
      background-color: #eecfa1;
    }
  }
  margin: 20px 15px 0 15px;
  position: relative;

  .lave-box {
    height: 112px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px;
    background-image: url('../../assets/img/pointsmall/bjt.png');
    background-size: 375px;
    // 可用积分
    .lave-points {
      flex: 1;
      // border: 1px solid greenyellow;
      text-align: center;

      .top {
        span {
          color: #ffffff;
          font-size: 22px;
        }
      }
      .down {
        span {
          color: #ffffff;
          font-size: 14px;
          text-align: center;
          // margin-left: 10px;
        }
      }
    }
    // 赚取积分
    .lave-earn {
      flex: 1;
      text-align: center;
      // border: 1px solid greenyellow;
      button {
        padding: 3px 15px;
        color: #7c5740;
        background-color: #fee0b4;
        border-radius: 50px;
        border: none;
        background-image: url('../../assets/img/pointsmall/anniu.png');
        // background-size: 375px;
      }
    }
    // line
    .line {
      height: 30px;
      width: 1px;
      background-repeat: repeat;
      background-color: #eecfa1;
    }
  }
}
.van-button__text {
  font-weight: 700;
}
// 实物兑换
.convert {
  margin-top: 26px;
  span {
    color: #333333;
    font-size: 16px;
    // font-weight: 700;
    margin-left: 20px;
  }
}

//兑换列表
.goods {
  margin: 12px;
  border-radius: 8px;
  background-color: #ffffff;

  .goods-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    // padding: 25px 40px;
    padding: 27px 25px;

    .goods-list-item {
      // width: 40vw;
      width: 130px;
      margin-bottom: 28px;
      // text-align: center;
      // border: 1px solid #000000;
      img {
        width: 130px;
        height: 130px;
        // width: 40vw;
        // height: 40vw;
      }
      .text {
        height: 35px;
        font-size: 12px;
        font-weight: 700;
        color: #333333;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .price {
        color: #7b7a7a;
        font-size: 10px;
        font-weight: 700;
        margin-top: 10px;
        margin-bottom: 10px;
        text-decoration: line-through;
      }
      .bg-color-orange-shop {
        height: 26px;
        width: 130px;
        font-size: 12px;
        border-radius: 2px;
        border: none;
      }
    }
  }
}
</style>
